import React, { ReactNode } from 'react';

import { I18nextProvider } from 'react-i18next';
import { CacheProvider } from './Cache.provider';
import { ConfirmationDialogueProvider } from './ConfirmationDialogue.provider';
import { DataFetchProvider } from './DataFetch.provider';
import { TokenProvider } from './Token.provider';
import { LayoutProvider } from './Layout.provider';
import { IQ11UserLoginProvider } from './IQ11Login.provider';
import { IQ11UserDataProvider } from './IQ11UserData.provider';
import { BankProvider } from './Bank.provider';
import { PaylinkProvider } from './Paylink.provider';
import { DatadogProvider } from './Datadog.provider';
import i18n from '../i18n/i18n';
import { AccessTokenFieldsProvider } from './AccessToken.provider';
import { HistoryFieldsProvider } from './History.provider';
import { AccountVerificationProvider } from './AccountVerification.provider';
import { InteracEmbedUrlProvider } from './InteracEmbedURL.provider';
import { FlexiblePaymentProvider } from './FlexiblePayment.provider';
import { SessionProvider } from './Session.provider';
import { LogTimestampProvider } from './LogTimestamp.provider';
import { LoggingProvider } from './Logging.provider';
import { ConvenienceFeesProvider } from './ConvenienceFees.provider';

export const MainProvider = ({ children }: { children: ReactNode }): React.JSX.Element => (
  <CacheProvider>
    <SessionProvider>
      <LogTimestampProvider>
        <DatadogProvider>
          <I18nextProvider i18n={i18n}>
            <ConfirmationDialogueProvider>
              <DataFetchProvider>
                <IQ11UserDataProvider>
                  <IQ11UserLoginProvider>
                    <BankProvider>
                      <TokenProvider>
                        <HistoryFieldsProvider>
                          <InteracEmbedUrlProvider>
                            <AccessTokenFieldsProvider>
                              <AccountVerificationProvider>
                                <PaylinkProvider>
                                  <FlexiblePaymentProvider>
                                    <ConvenienceFeesProvider>
                                      <LayoutProvider>
                                        <LoggingProvider>
                                          <BankProvider>{children}</BankProvider>
                                        </LoggingProvider>
                                      </LayoutProvider>
                                    </ConvenienceFeesProvider>
                                  </FlexiblePaymentProvider>
                                </PaylinkProvider>
                              </AccountVerificationProvider>
                            </AccessTokenFieldsProvider>
                          </InteracEmbedUrlProvider>
                        </HistoryFieldsProvider>
                      </TokenProvider>
                    </BankProvider>
                  </IQ11UserLoginProvider>
                </IQ11UserDataProvider>
              </DataFetchProvider>
            </ConfirmationDialogueProvider>
          </I18nextProvider>
        </DatadogProvider>
      </LogTimestampProvider>
    </SessionProvider>
  </CacheProvider>
);
